import clsx from 'clsx';
import React from 'react';

const TabButton = ({ selected, disabled, children }) => {
  return (
    <div
      className={clsx(
        'relative block w-full h-full rounded-md px-3 py-2 text-sm font-medium text-left',
        'border border-input transition-colors outline-none cursor-pointer',
        {
          'border-primary': selected,
          'hover:bg-accent/50': !selected && !disabled,
          'cursor-not-allowed opacity-50': disabled,
        },
      )}
    >
      <div className="flex-1 pr-6">{children}</div>
      <span
        className={clsx(
          'absolute right-2 top-2 flex size-4 items-center justify-center rounded-full border transition-colors',
          selected ? 'border-primary' : 'border-input',
        )}
      >
        {selected && <span className="size-2 rounded-full bg-primary" />}
      </span>
    </div>
  );
};

export default TabButton;
